React = require 'react'
Router = require 'react-router'
Route = Router.Route
DefaultRoute = Router.DefaultRoute
Root = require './app/components/Root.cjsx'
Index = require './app/components/Index.cjsx'
About = require './app/components/About.cjsx'

Routes =
  React.createElement(Route, {"handler": (Root), "path": '/'},
    React.createElement(DefaultRoute, {"handler": (Index)}),
    React.createElement(Route, {"path": '/about', "handler": (About)})
  )

module.exports = Routes



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./Routes.cjsx
 **/